export enum StorageProperties {
  clinicalRecordsState = "bp:clinical:records:state",
  tenantId = "bp:tenant:id",
  locked = "bp:locked",
  lockedTestingDisabled = "bp:locked:testing:disabled",
  lockedTestingTimeout = "bp:locked:testing:timeout"
}
